import AgentActivity from 'models/agent_activity';
import removeOptionalUpgradeNotifications from 'actions/version/lib/remove_optional_upgrade_notifications';
import runLoggedOut from 'actions/lib/run_logged_out';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import UserSessionResetter from 'actions/user/lib/user_session_resetter';

export default class LogOut extends UserSessionResetter {
  run() {
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.LOG_OUT });
    this.reset();

    removeOptionalUpgradeNotifications(this.context);
    runLoggedOut(this.context);
    this.context.router.navigateToPath('/user/logout');
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/user/log_out.js